import React from "react";
import { ThemePreference } from "../../../Theme/ThemePreference";

export const ThemePreferencePage = () => <ThemePreference />;
